// extracted by mini-css-extract-plugin
export default {"form":"Search_form__Ifvmr","form__input":"Search_form__input__+uBJ5","search":"Search_search__EMjZA","error":"Search_error__aWiSv"};